var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebstorm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.62015 28.497L0.416016 3.52806L8.23936 0.274414L13.1747 3.2356L17.7809 0.786223L27.2494 4.442L21.9119 31.5313L4.62015 28.497Z",
    fill: "url(#paint0_linear_1320_7634)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7087 10.84L27.6508 0.859762L20.3758 0.238281L9.00635 11.0959L12.0406 25.1341L17.7802 29.0823L31.7087 20.8203L28.2722 14.4227L31.7087 10.84Z",
    fill: "url(#paint1_linear_1320_7634)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.458 9.34057L28.2729 14.4221L31.7094 10.8394L29.2234 4.66113L25.458 9.34057Z",
    fill: "url(#paint2_linear_1320_7634)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8235 6.12402H6.26514V25.6824H25.8235V6.12402Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12961 22.0274H15.4777V23.2338H8.12961V22.0274ZM17.7077 15.6297L18.7313 14.3502C19.3968 14.9491 20.2498 15.298 21.1441 15.3373C21.8753 15.3373 22.314 15.0448 22.314 14.5696C22.314 14.0943 22.0215 13.875 20.7055 13.546C19.0969 13.1073 18.0733 12.6686 18.0733 11.06V10.9503C18.0733 9.48804 19.2432 8.50098 20.8517 8.50098C21.936 8.50488 22.9891 8.86448 23.8494 9.52459L22.9355 10.8772C22.3513 10.4114 21.6346 10.1427 20.8882 10.1095C20.2668 10.1095 19.8646 10.402 19.8646 10.8407C19.8646 11.389 20.1937 11.5718 21.5828 11.9009C23.1914 12.3395 24.1419 12.9245 24.1419 14.3502C24.1419 15.9588 22.9355 16.9093 21.2173 16.9093C19.9343 16.9036 18.6933 16.4511 17.7077 15.6297ZM16.1357 8.68377L14.9293 13.3632L13.5401 8.68377H12.1875L10.7983 13.3632L9.59192 8.68377H7.69092L10.0306 16.7996H11.5295L12.8456 12.0836L14.1616 16.763H15.6605L18.0002 8.64721L16.1357 8.68377Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1320_7634",
    x1: 12.0048,
    y1: 1.61097,
    x2: 22.529,
    y2: 29.6407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#00CDD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#2086D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1320_7634",
    x1: 13.8064,
    y1: 4.09512,
    x2: 31.3198,
    y2: 20.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFF045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#00CDD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1320_7634",
    x1: 1064.12,
    y1: -2337.76,
    x2: 1140.9,
    y2: -2409.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#00CDD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#2086D7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebstorm);
export default __webpack_public_path__ + "static/media/webstorm.7a5ee564d436242df7b9318a74cb6a8a.svg";
export { ForwardRef as ReactComponent };